import * as React from 'react';
import { createContext, useContext, useMemo } from 'react';

import { useLayer } from '@coursera-web/statsig';

const LAYER_NAME = 'specialization-reviews-layer';

export type SpecializationReviewsExperimentConfig = {
  showReviews: boolean;
  showKimAnchor: boolean;
};

export const SpecializationReviewsExperimentContext = createContext<SpecializationReviewsExperimentConfig>({
  showReviews: false,
  showKimAnchor: false,
});

const SpecializationReviewsExperimentProvider = ({ children }: React.PropsWithChildren) => {
  const layer = useLayer(LAYER_NAME);
  const showReviews = layer.get('enableReviews', false);
  const showKimAnchor = layer.get('enableKIM', false);

  const value = useMemo(() => {
    return { showReviews, showKimAnchor };
  }, [showReviews, showKimAnchor]);

  return (
    <SpecializationReviewsExperimentContext.Provider value={value}>
      {children}
    </SpecializationReviewsExperimentContext.Provider>
  );
};

export const useSpecializationReviewsExperimentConfig = () => useContext(SpecializationReviewsExperimentContext);

export default SpecializationReviewsExperimentProvider;
